import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeaderFour({
  logo,
  isLivingMaderas,
  theme,
  toggleTheme,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [theme]);

  return (
    <header className="living-brand-bar">
      <Link
        className="living-brand-lockup"
        to="/"
        aria-label={t("app.marcaInicio")}
      >
        {isLivingMaderas ? (
          <>
            <span className="living-brand-mark" aria-hidden="true"></span>
            <span className="living-brand-copy">
              <span className="living-brand-script">living</span>
              <strong>MADERAS</strong>
            </span>
          </>
        ) : (
          <img
            className="living-dynamic-brand-logo"
            src={logo}
            alt="Segura"
          />
        )}
      </Link>

      <button
        type="button"
        className="theme-toggle-btn"
        onClick={toggleTheme}
        title={
          theme === "dark" ? t("app.modoClaro") : t("app.modoOscuro")
        }
        aria-label={
          theme === "dark" ? t("app.modoClaro") : t("app.modoOscuro")
        }
        aria-pressed={theme === "light"}
      >
        <i
          aria-hidden="true"
          className={
            theme === "dark" ? "fa-light fa-sun" : "fa-light fa-moon"
          }
        ></i>
      </button>
    </header>
  );
}
